import 'graphql';
import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { AppProviders } from './app/providers.jsx';
import { restoreSession } from './core/auth/session.js';
import { useConnectionStore } from './core/stores/connectionStore.js';
import { initPwaInstallCapture } from './features/install/pwaInstall.js';
import './styles/index.css';

initPwaInstallCapture();

function AppBootstrap() {
  useEffect(() => {
    restoreSession();

    const setOnline = useConnectionStore.getState().setOnline;
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return <AppProviders />;
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AppBootstrap />
  </StrictMode>
);
